/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

jQuery(document).ready(function() {
		const discountUpdate = (variant) => {
			if(!variant) return;
		
			const discountEl = document.querySelector("[data-discount]");
		
			if (discountEl) {
				discountEl.classList.remove("hidden");
		
				const discountValueEl = discountEl.querySelector("[data-discount-value]");
				const price = variant.price;
				const comparePrice = variant.compare_at_price;
		
				if (price && comparePrice) {
					if(price !== comparePrice) {
						discountValueEl.innerText = `${Math.round(((comparePrice - price) / comparePrice) * 100)}`;
					} else {
						if (!discountEl.classList.contains("hidden")) {
							discountEl.classList.add("hidden");
						}
					}
				}
			}
		}

		const variantMetafieldTextUpdate = (variant) => {
			const productJsonEl = document.querySelector("[data-product-json]")
			const variantLabelEl = document.querySelector("[data-variant-custom-text]");

			if (variantLabelEl && productJsonEl) {
				const productJson = JSON.parse(productJsonEl.innerHTML);
				if (productJson) {
					const metaFields = productJson.variants_metafields;

					if (metaFields) {
						const selectedMetaVariant = metaFields.find(item => item.id === variant.id);
						
						if (selectedMetaVariant) {
							const customMetaText = selectedMetaVariant.metafields[0]?.custom_variant_text;

							if (customMetaText) {
								variantLabelEl.innerText = customMetaText;
								variantLabelEl.classList.remove("hidden");
							} else {
								variantLabelEl.innerText = "";
								if (!variantLabelEl.classList.contains("hidden")) variantLabelEl.classList.add("hidden");
							}
						}
					}
				}

			}
		}

		const hideDescriptionPartOnClick = () => {
			document.addEventListener("click", (e) => {
				if (e.target.closest("[data-variant-button]")) {
					const button = e.target.closest("[data-variant-button]");
					const customDescrEl = document.querySelector("[data-product-custom-description]");
					
					if(!customDescrEl) return;

					if (button.hasAttribute("data-hide-description")) {
						if (!customDescrEl.classList.contains("hide-text-part")) customDescrEl.classList.add("hide-text-part");
					} else {
						customDescrEl.classList.remove("hide-text-part");
					}
				}
			})
		}

		document.addEventListener('variant:changed', function(event) {
		  var variant = event.detail.variant;
			discountUpdate(variant);
			variantMetafieldTextUpdate(variant);
		});

		hideDescriptionPartOnClick();

    setTimeout(function() {

    	var uniqueTextV = document.getElementsByClassName("v-stl-uniquetext");
			var shopTheLookHotspots = document.getElementsByClassName("ShopTheLook__Dot");

			shopTheLookHotspots[0]?.addEventListener("click", function() {
				uniqueTextV[0].classList.add('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[1]?.addEventListener("click", function() {
				uniqueTextV[1].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[2]?.addEventListener("click", function() {
				uniqueTextV[2].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[3]?.addEventListener("click", function() {
				uniqueTextV[3].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[4]?.addEventListener("click", function() {
				uniqueTextV[4].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[5]?.addEventListener("click", function() {
				uniqueTextV[5].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[6]?.addEventListener("click", function() {
				uniqueTextV[6].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
			});
		}, 5000);
});

if (!window.customElements.get('announce-timer')) {
	class AnnounceTimer extends HTMLElement {
		constructor() {
			super();
			this.interval = null;
			this.startKey = 'announce-timer-start-time';
		}
	
		connectedCallback() {
			const hourEl = this.querySelector('[data-timer-hours]');
			const minuteEl = this.querySelector('[data-timer-minutes]');
			const secondEl = this.querySelector('[data-timer-seconds]');
	
			let startTime = sessionStorage.getItem(this.startKey);
			if (!startTime) {
				const now = Date.now();
				startTime = now - 2 * 60 * 60 * 1000;
				sessionStorage.setItem(this.startKey, startTime);
			} else {
				startTime = parseInt(startTime, 10);
			}
	
			this.interval = setInterval(() => {
				const now = Date.now();
				const elapsed = Math.floor((now - startTime) / 1000);
				const hours = Math.floor(elapsed / 3600);
				const minutes = Math.floor((elapsed % 3600) / 60);
				const seconds = elapsed % 60;
	
				hourEl.textContent = String(hours).padStart(2, '0');
				minuteEl.textContent = String(minutes).padStart(2, '0');
				secondEl.textContent = String(seconds).padStart(2, '0');
			}, 1000);
		}
	
		disconnectedCallback() {
			if (this.interval) {
				clearInterval(this.interval);
			}
		}
	}

	window.customElements.define('announce-timer', AnnounceTimer);
}
